import { inject, Injectable } from "@angular/core";
import { Params, Router, UrlTree } from "@angular/router";
import { ROUTER_OUTLET_NAME } from "@modules/+new/shared/universal-modal/entities/magic";
import { CHANGE_USER_INFO } from "@helpers/constants";
import { UserInfoRouteNames } from "@modules/shared/modals/change-personal-info/domain/entities/change-user-info.model";

@Injectable({
	providedIn: "root"
})
export class ChangeUserInfoNavigationService {
	private readonly router = inject(Router);

	public gotoByNavigationUrl(path: UserInfoRouteNames): void {
		const urlTree = this.gotoByUrlTree(path);
		this.router.navigateByUrl(urlTree);
	}

	private gotoByUrlTree(path: UserInfoRouteNames): UrlTree {
		return this.router.createUrlTree([{ outlets: { [ROUTER_OUTLET_NAME]: [CHANGE_USER_INFO, path] } }]);
	}

	public navigateToMyAccount(): void {
		this.router.navigateByUrl("/my-account");
	}

	public navigateToReviewKyc(): void {
		this.router.navigateByUrl("/review-data");
	}

	public updateQpAndNavigate(path: UserInfoRouteNames, queryParams: Params): void {
		const route = { outlets: { [ROUTER_OUTLET_NAME]: [CHANGE_USER_INFO, path] } };
		this.router.navigate([route], { queryParams, queryParamsHandling: "merge" });
	}
}
